import React from 'react';

export default function ScanHistory({ scannedItems }) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 mb-6" data-testid="scan-history-section">
      <h3 className="text-xl font-bold text-white mb-4">
        Recently Scanned{' '}
        {scannedItems.length > 0 && <span className="text-[#00D26A]">({scannedItems.length})</span>}
      </h3>
      {scannedItems.length === 0 ? (
        <p className="text-zinc-500 text-sm" data-testid="scan-history-empty">
          No scans yet. Tap "Scan Barcode" above to add your first item — it will appear here.
        </p>
      ) : (
        <>
          <div className="space-y-3">
            {scannedItems.slice(0, 5).map((item, index) => (
              <div
                key={item.scanned_at || item.id || index}
                className="flex items-center justify-between p-4 bg-black/40 border border-zinc-800 rounded-lg"
                data-testid="scan-history-item"
              >
                <div>
                  <div className="font-semibold text-[#FFD700] font-mono" data-testid="scan-barcode">{item.barcode}</div>
                  <div className="text-sm text-zinc-400" data-testid="scan-type">{item.type}</div>
                </div>
                <div className="text-sm text-zinc-500" data-testid="scan-timestamp">
                  {new Date(item.scanned_at || item.scannedAt).toLocaleTimeString()}
                </div>
              </div>
            ))}
          </div>
          {scannedItems.length > 5 && (
            <p className="text-sm text-zinc-500 text-center mt-3">
              + {scannedItems.length - 5} more items
            </p>
          )}
        </>
      )}
    </div>
  );
}
